import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { IMG } from "@/data/content";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen grid lg:grid-cols-2">
    <div className="flex flex-col px-6 sm:px-12 py-8">
      <div className="flex items-center justify-between">
        <Link to="/" className="text-foreground" data-testid="auth-home-link"><Logo className="h-8" /></Link>
        <ThemeToggle />
      </div>
      <div className="flex-1 flex items-center">
        <div className="w-full max-w-md mx-auto py-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-3 text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
    <div className="hidden lg:block relative overflow-hidden">
      <img src={IMG.meeting} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#0b0f19]/70" />
      <div className="absolute inset-0 bg-brand opacity-40 mix-blend-multiply" />
      <div className="absolute bottom-0 p-12 text-white">
        <div className="font-mono text-xs uppercase tracking-[0.22em] text-white/70">Sliance AI</div>
        <p className="mt-4 font-display text-3xl font-bold leading-tight max-w-md">Your AI Marketing Team. One Simple Platform.</p>
      </div>
    </div>
  </div>
);
